<template>
<div class="vm-action-collapse" >
    <div >
        <svg v-if="!collapsed" height="26" version="1.1" width="26" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.7);">
            <path d="M 13 10.59375 L 21.765625 19.179688 C 22.15625 19.5625 22.78125 19.558594 23.171875 19.171875 L 24.707031 17.636719 C 25.097656 17.242188 25.097656 16.609375 24.703125 16.21875 L 13.707031 5.292969 C 13.511719 5.097656 13.257813 5 13 5 C 12.742188 5 12.488281 5.097656 12.292969 5.292969 L 1.296875 16.21875 C 0.902344 16.609375 0.902344 17.242188 1.292969 17.636719 L 2.828125 19.171875 C 3.21875 19.558594 3.84375 19.5625 4.234375 19.179688 Z"/>
        </svg>
        <svg v-if="collapsed" height="26" version="1.1" width="26" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.7);">
            <path d="M 13 15.40625 L 21.765625 6.820313 C 22.15625 6.4375 22.78125 6.441406 23.171875 6.828125 L 24.707031 8.363281 C 25.097656 8.757813 25.097656 9.390625 24.703125 9.78125 L 13.707031 20.707031 C 13.511719 20.902344 13.257813 21 13 21 C 12.742188 21 12.488281 20.902344 12.292969 20.707031 L 1.296875 9.78125 C 0.902344 9.390625 0.902344 8.757813 1.292969 8.363281 L 2.828125 6.828125 C 3.21875 6.441406 3.84375 6.4375 4.234375 6.820313 Z"/>
        </svg>
    </div>
</div>
</template>
<script>

export default {
name: 'vm-collapse-action',
props: {
    collapsed: {
        type: Boolean,
        default: false
    }
},
data() {
    return {
        
    }
},
methods: {
    handleClick(e) {
        this.$emit('input', e.srcElement.value);
    }
}
}
</script>
<style scoped>

.vm-action-collapse {
    padding-top: 7px;
    padding-right: 10px;
}

.vm-action-collapse path {
    fill: white;
}

</style>
